import { CourseItem } from '@atlassian/learning-components';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { ResourceCard } from 'src/components/ResourceCard';
import { ResourceType } from 'src/constants';
import { formatDurationFromMinutes, getProductTag } from 'src/utils/resourceCardUtils';
import { getContentProduct } from 'src/utils/getContentProduct';
import { getCourseUrl, withPrefix } from 'src/utils/getUrl';

interface CoursePopupProps {
  course: CourseItem;
  pathSlug: string;
  handlePopupClick: (slug: string, title: string) => void;
}

export const CoursePopup: React.FC<CoursePopupProps> = ({
  course: { slug, title, product, lessonsCollection },
  handlePopupClick,
  pathSlug,
}) => {
  const navigate = useNavigate();

  const productTag = getProductTag(product);
  const courseDuration = useMemo(
    () => lessonsCollection.items.reduce((acc, lesson) => acc + (lesson?.duration || 0), 0),
    [lessonsCollection],
  );

  const tags = [
    ...(courseDuration ? [{ label: formatDurationFromMinutes(courseDuration) }] : []),
    { label: 'course' },
    ...productTag,
  ];

  const handleNavigate = (): void => {
    handlePopupClick(slug, title);
    navigate(getCourseUrl(slug, pathSlug));
  };

  return (
    <div id="course-popup">
      <ResourceCard
        contentType={ResourceType.SmCourse}
        product={getContentProduct(product)}
        title={title}
        link={withPrefix(getCourseUrl(slug))}
        onClick={handleNavigate}
        target="_self"
        tags={tags}
      />
    </div>
  );
};
